import { ToastContent } from "../../../shared/components";
import { useToast } from "../../../shared/hooks";
import { FinancialService } from "../../../shared/services/api/financial/FinancialService";

export interface IGenerateInvoice {
	clientId: string;
	dueDate: string;
	reference: string;
	id: string; // só utilizado no retorno ou leitura
	value: string;
	installmentsNumber: number;
	gateway: "EMPTY";
	status: "pending";
}

// Tipagem correta para envio
type GenerateInvoicePayload = Omit<IGenerateInvoice, "id">;

export const useGenerateInvoice = (dataIni: string, dataFim: string, setIsLoading: (v: boolean) => void, onSuccess: () => void) => {
	const toastHandler = useToast();

	const handleGenerateInvoice = async (payload: GenerateInvoicePayload) => {
		setIsLoading(true);

		try {
			// Força os valores fixos no payload
			const cleanPayload: GenerateInvoicePayload = {
				...payload,
				status: "pending",
				gateway: "EMPTY",
			};

			const result = await FinancialService.generateInvoice(cleanPayload, dataIni, dataFim);

			if (result instanceof Error) {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title="Erro" content="Erro ao gerar fatura" />,
				});
			} else {
				toastHandler.present({
					type: "success",
					position: "top-right",
					messageOrContent: <ToastContent title="Sucesso" content="Fatura gerada com sucesso" />,
				});
				onSuccess();
			}
		} catch (error: any) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content="Erro inesperado ao gerar fatura" />,
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { handleGenerateInvoice };
};
